/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { DeleteRequestDto } from '../models/DeleteRequestDto';
import type { DeleteSubjectsResponseDto } from '../models/DeleteSubjectsResponseDto';
import type { InputName } from '../models/InputName';
import type { InputsResponseDto } from '../models/InputsResponseDto';
import type { ReplaceRequestDto } from '../models/ReplaceRequestDto';
import type { SolutionsRequestDto } from '../models/SolutionsRequestDto';
import type { SolutionsResponseDto } from '../models/SolutionsResponseDto';
import type { TestingResponseDto } from '../models/TestingResponseDto';
import type { UpsertRequestDto } from '../models/UpsertRequestDto';

export class DiscoveryService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get Solutions
   * Get ranked benefit solutions for an employee with snapshot tracking.
   *
   * The handler is the single fetch point for the user profile: it loads
   * the profile from the monolith once, then threads it through both the
   * inference layer (which needs it to filter orphan per-dependent
   * inputs) and the solutions service (which forwards it to the engine).
   * @param requestBody
   * @param xUserId
   * @returns SolutionsResponseDto Successful Response
   * @throws ApiError
   */
  public getSolutionsDiscoveryV1SolutionsPost(
    requestBody: SolutionsRequestDto,
    xUserId?: string | null
  ): CancelablePromise<SolutionsResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/discovery/v1/solutions',
      headers: {
        'X-User-ID': xUserId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Post Preference Sets
   * Apply one atomic operation to the scope's input set.
   * @param requestBody
   * @returns InputsResponseDto Successful Response
   * @throws ApiError
   */
  public postPreferenceSetsDiscoveryV1InputsPreferenceSetsPost(
    requestBody: UpsertRequestDto | DeleteRequestDto | ReplaceRequestDto
  ): CancelablePromise<InputsResponseDto> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/discovery/v1/inputs/preference_sets',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Preference Sets
   * Read inputs under `(employee_id, set_id)`, optionally filtered.
   * @param employeeId Owner identity
   * @param setId Preference-set partition
   * @param inputName Optional equality filter on input_name
   * @param subjectId Optional equality filter on subject_id. Omitted = no filter (NOT the employee — employee-only reads aren't expressible here)
   * @returns InputsResponseDto Successful Response
   * @throws ApiError
   */
  public getPreferenceSetsDiscoveryV1InputsPreferenceSetsGet(
    employeeId: string,
    setId: string,
    inputName?: InputName | null,
    subjectId?: string | null
  ): CancelablePromise<InputsResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/discovery/v1/inputs/preference_sets',
      query: {
        employee_id: employeeId,
        set_id: setId,
        input_name: inputName,
        subject_id: subjectId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Subject
   * Delete all of a subject's discovery data across every set —
   * rows belonging to the subject and rows targeting it via a
   * dependent `target_ref`.
   *
   * The count includes rows that referenced a removed row (priority
   * rows).
   *
   * Idempotent — a subject with no stored data returns `deleted=0`
   * (never 404).
   * @param employeeId Owner identity
   * @param subjectId Narrow to one subject (a dependent). Omit to clear the whole employee — their own data and every dependent's, across all sets.
   * @returns DeleteSubjectsResponseDto Successful Response
   * @throws ApiError
   */
  public deleteSubjectDiscoveryV1SubjectsDelete(
    employeeId: string,
    subjectId?: string | null
  ): CancelablePromise<DeleteSubjectsResponseDto> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/discovery/v1/subjects',
      query: {
        employee_id: employeeId,
        subject_id: subjectId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Testing Inventory
   * Fetch inventory via the real medical plans service (mocked in tests).
   *
   * Builds a synthetic profile inline (no monolith profile fetch) so
   * the endpoint focuses solely on exercising the inventory ext-api
   * path.
   * @returns TestingResponseDto Successful Response
   * @throws ApiError
   */
  public getTestingInventoryDiscoveryV1TestingInventoryGet(): CancelablePromise<TestingResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/discovery/v1/_testing/inventory',
    });
  }
}
